import React, { useState } from "react";
import MatchRow from "./MatchRow";
import selectdropdownsvg from "../../../images/selectdropdownsvg.svg";
import whiteselectdown from "../../../images/whiteselectdown.svg";
import { useDispatch } from "react-redux";
import { addBet } from "../../../store/betslip-slice";

const LeagueList = ({
  filteredAndSortedData,
  expandedLeagues,
  setExpandedLeagues,
  getOddsGroup,
  selectedOdd,
  setSelectedOdd,
}) => {
  const dispatch = useDispatch();
  const [selectedBets, setSelectedBets] = useState({});
  // Toggle league expansion
  const toggleLeagueExpansion = (leagueIndex) => {
    setExpandedLeagues((prev) => ({
      ...prev,
      [leagueIndex]: !prev[leagueIndex],
    }));
  };
  // Handle odd selection and bet placement
  const handleOddSelection = (match, odd) => {
    const betKey = `${match.team1}-${match.team2}-${odd.label}`;

    // Create a new selectedBets object
    const updatedSelectedBets = { ...selectedBets };

    // If the bet already exists, remove it (toggle behavior)
    if (updatedSelectedBets[betKey]) {
      delete updatedSelectedBets[betKey];
    } else {
      // Add the new bet
      updatedSelectedBets[betKey] = odd;
    }

    // Update local state
    setSelectedBets(updatedSelectedBets);

    // Dispatch to Redux store
    if (updatedSelectedBets[betKey]) {
      dispatch(
        addBet({
          match: {
            team1: match.team1,
            team2: match.team2,
            date:
              match.details.find((d) => d.text.includes("/"))?.text ||
              "Unknown Date",
          },
          odd: odd,
        })
      );
    } else {
      // You might want to add a removeBet action in your slice
      // dispatch(removeBet({ match, odd }));
    }
  };

  return (
    <div className="main-dashboard-block">
      {filteredAndSortedData &&
        filteredAndSortedData.map((league, leagueIndex) => (
          <div key={leagueIndex} className="main-title-block">
            {/* League Title */}
            <div
              className="title-block flex justify-between items-center cursor-pointer max-sm:p-[10px_15px] p-[10px_23px] bg-forestGreen"
              onClick={() => toggleLeagueExpansion(leagueIndex)}
            >
              <span className="text-white max-sm:text-xs text-sm font-medium leading-tight">
                {league.leagueTitle}
              </span>
              <img
                src={whiteselectdown}
                alt="downarrow"
                className={`transition-transform duration-300 ${
                  expandedLeagues[leagueIndex] ? "rotate-180" : ""
                }`}
              />
            </div>

            {/* Title Wrapper - Only show if league is expanded or not toggled yet */}
            {expandedLeagues[leagueIndex] !== false &&
              league.titleWrps.map((titleWrp, titleWrpIndex) => (
                <div key={titleWrpIndex} className="title-wrp">
                  {titleWrp.matches.map((match, matchIndex) => (
                    <MatchRow
                      key={matchIndex}
                      match={match}
                      getOddsGroup={getOddsGroup}
                      selectedOdd={Object.values(selectedBets).find(
                        (selectedOdd) =>
                          match.odds.some((group) =>
                            group.some(
                              (odd) =>
                                JSON.stringify(odd) ===
                                JSON.stringify(selectedOdd)
                            )
                          )
                      )}
                      setSelectedOdd={(odd) => handleOddSelection(match, odd)}
                    />
                  ))}
                </div>
              ))}
          </div>
        ))}
    </div>
  );
};

export default LeagueList;
